<template>
  <div class="details3">
    <div class="left_basic_info">
      <div class="details3_title">基本信息</div>
      <div class="details3_body">
        <div class="patientInfo">
          <span class="name">
            <span
              class="patientName"
              :class="{ isPassAway: patientInfo.isPassAway }"
            >
              {{ patientInfo.patientName }}
            </span>
            <span class="tag" v-if="patientInfo.isPassAway">逝者</span>
          </span>
          <span>
            <Icon v-if="patientInfo.genderName == '男'" type="md-male" />
            <Icon v-else type="md-female" />
          </span>
          <span class="gender">{{ patientInfo.genderName }}</span>
          <span class="age">
            <template v-if="patientInfo.patientAge > 1"
              >{{ patientInfo.patientAge }}岁</template
            >
            <template v-else>
              <template v-if="patientInfo.birthMonth">{{
                patientInfo.birthMonth + "个月"
              }}</template>
            </template>
          </span>
          <span class="phone">{{ patientInfo.cellphoneNo }}</span>
        </div>
        <div class="btn-group" v-if="hasBaiHui">
          <Button v-uEdition="'YZ-12'" size="small" @click="onAddQuestion"
            >提问题</Button
          >
          <Button
            v-uEdition="'YZ-25'"
            text
            size="small"
            @click="addDiseaseCourseRecord"
            >记服药信息</Button
          >
        </div>
        <div class="item"></div>
        <div class="item tag-bl">
          <div class="patientinfo-other" v-if="hasBaiHui">
            <div class="tag-box fjcsb">
              <span class="tag-box-title">标签:</span>
              <span @click="openPatientLabels" class="tag-box-btn"
                >贴标签<Icon type="md-create"
              /></span>
            </div>
            <patientLabels
              v-if="patientInfo.patientCode"
              ref="patientLabelsRef"
              :info="patientInfo"
              :showEditBtn="false"
            />
          </div>
        </div>
        <div class="item" v-for="(item, index) in listFilter" :key="index">
          <span class="label">{{ item.label }}</span>
          <span class="value" v-if="item.label == '首诊介绍人'">
            <template
              v-if="patientInfo[item.key] && patientInfo[item.key].userName"
            >
              <span class="mr05">{{ patientInfo[item.key].userName }}</span>
              <span>{{ patientInfo[item.key].userMobile }}</span>
            </template>
            <span v-else>/</span>
          </span>

          <span class="value" v-else
            >{{
              patientInfo[item.key] || (item.label == "既往史" ? "健康" : "/")
            }}
            <remarks-input
              v-if="item.label == '备注'"
              v-model="patientInfo[item.key]"
              placeholder="点击输入备注"
              mode="label"
              @change="init"
              :patientCode="patientInfo.patientCode"
            />
            <hobby
              v-if="item.label == '喜好、生活状态'"
              :value="patientInfo"
              :isInput="false"
              @change="init"
            />
          </span>
        </div>
        <el-amap
          v-if="showMap"
          vid="amapDemo"
          :center="mapCenter"
          :zoom="15"
          class="amap-demo"
        >
          <el-amap-marker
            v-for="(marker, index) in markers"
            :key="index"
            :position="marker"
          ></el-amap-marker>
        </el-amap>
      </div>
    </div>
    <div class="right">
      <div class="details3_title">
        <div class="tabs">
          <span
            @click="clickTabs(item)"
            v-for="item in tabs"
            :key="item.value"
            class="tabs_item"
            :class="{ active: item.value == tabsValue }"
            >{{ item.label }}</span
          >
        </div>
      </div>
      <div class="details3_body">
        <userRecord
          v-show="tabsValue == 1"
          ref="userRecordRef"
          :patientCode="patientCode"
          :hasBaiHui="hasBaiHui"
        />
        <userQuestions
          v-if="tabsValue == 2 && hasAuth('YZ-12')"
          :patientCode="patientCode"
        />
        <handPic
          v-if="tabsValue == 3"
          :info="patientInfo"
          :handRareData="handRareData"
        />
        <caseAnalysis v-if="tabsValue == 4" :patientCode="patientCode" />
      </div>
    </div>
    <askQuestion ref="askQuestionRef" :patientCode="patientCode" />
  </div>
</template>

<script>
import { hasAuth } from "@/utils/uEdition.js";
import userRecord from "./com/userRecord/index.vue";
import caseAnalysis from "./com/caseAnalysis/index.vue";
import askQuestion from "./com/userQuestions/askQuestion.vue";
import userQuestions from "./com/userQuestions/index.vue";
import handPic from "@/com/handPic";
import PatientLabel from "../patientInfo/com/patientLabel.vue";
import { isHasSystemPerm } from "@/directive/permission/index.js";
import { mapGetters } from "vuex";

export default {
  props: {
    patientCode: {
      type: String,
      default: "",
    },
  },
  components: {
    userRecord,
    caseAnalysis,
    handPic,
    PatientLabel,
    userQuestions,
    askQuestion,
  },
  computed: {
    ...mapGetters(["is999", "dicts"]),
    handRareData() {
      return this.dicts.HAND_RARE_DATA || [];
    },
    labelStr() {
      let arr = [];
      if (this.patientInfo.courseCrowdName) arr.push("第三类人群");
      if (this.patientInfo.isCourseManage) arr.push("病程管理");
      // if (this.isAnAn) arr.push("安安适用人群")
      return arr.join(" / ");
    },
    listFilter() {
      let arr =
        this.patientInfo.genderName == "女"
          ? this.list
          : this.list.filter((item) => item.label != "生育史");
      return arr.filter((i) => !i.hide);
    },
    // 3、手相解读：租户有云诊版本配置的手诊功能时显示
    showHandPic() {
      return isHasSystemPerm(["YZ:YZ-01"]);
    },
    // 2、病案分析：租户有百会的病案分析权限，或者云诊病因分析功能权限时显示
    showCaseAnalysis() {
      return (
        (isHasSystemPerm(["YZ:YZ-03"]) || isHasSystemPerm(["1000:1027"])) &&
        hasAuth("YZ-03")
      );
    },
    // 3、服药信息记录：租户有百会权限时显示
    // 1、用户提问：租户有百会权限时显示
    hasBaiHui() {
      return isHasSystemPerm(["1000"]);
    },
  },
  data() {
    return {
      isAnAn: false,
      showMap: false,
      mapCenter: [0, 0],
      markers: [],
      tabsValue: 1,
      tabs: [],
      list: [],
      patientInfo: {},
    };
  },
  methods: {
    setList() {
      this.list = [
        {
          label: "来源渠道",
          key: "patientSourceName",
        },
        {
          label: "出生年月",
          key: "patientBirthday",
        },
        {
          label: "婚否",
          key: "maritalName",
        },
        {
          label: "职业",
          key: "-",
        },
        {
          label: "民族",
          key: "nation",
        },
        {
          label: "喜好、生活状态",
          key: "hobbyInfo",
        },
        {
          label: "首诊介绍人",
          key: "firstReferrerVO",
          hide: !this.is999,
        },

        {
          label: "首诊时间",
          key: "firstVisitDate",
        },
        {
          label: "首诊诊断",
          key: "firstVisitDiseaseName",
        },
        {
          label: "最近就诊时间",
          key: "lastTimeVisitDate",
        },
        {
          label: "最近就诊诊断",
          key: "lastTimeDiseaseName",
        },

        {
          label: "节育史",
          key: "birthControlHistory",
        },
        {
          label: "既往史",
          key: "pastHistory",
        },
        {
          label: "生育史",
          key: "birthHistory",
        },
        {
          label: "过敏史",
          key: "allergyHistory",
        },
        {
          label: "家族史",
          key: "familyHistory",
        },
        {
          label: "使用其他药物情况",
          key: "useDrugRecord",
        },
        {
          label: "备注",
          key: "otherInfo",
        },
        {
          label: "地址",
          key: "address",
        },
      ];
    },
    hasAuth(code) {
      return hasAuth(code);
    },
    addDiseaseCourseRecord() {
      this.$refs.userRecordRef.showEditWin();
    },
    onAddQuestion() {
      this.$refs.askQuestionRef.open();
    },
    openLabel() {
      this.$refs.patientLabel.showFun();
    },
    clickTabs(item) {
      this.tabsValue = item.value;
    },
    setAmap() {
      let x = this.patientInfo.locationX;
      let y = this.patientInfo.locationY;
      if (x && y) {
        this.mapCenter = [x, y];
        this.markers = [this.mapCenter];
        this.showMap = true;
      } else if (this.patientInfo.address) {
        this.postAddress();
      }
    },
    postAddress() {
      let city = this.patientInfo.cityName || "上饶市";
      let arrStr = this.patientInfo.address;
      var geocoder = new AMap.Geocoder({ city });

      geocoder.getLocation(arrStr, (status, result) => {
        if (status === "complete" && result.info === "OK") {
          let loc = result.geocodes[0].location;
          let lnglat = [loc.lng, loc.lat];
          this.mapCenter = lnglat;
          this.markers = [this.mapCenter];
          this.showMap = true;
        }
      });
    },
    init() {
      this.api2("getPatientBaseInfo", {
        patientCode: this.patientCode, //	患者code
      }).then((res) => {
        this.patientInfo = res.result;
        this.setAmap();
        // 暂时关闭
        // this.getPatientAnanAuth();
        this.setList();
      });
    },
    updateInfo(obj) {
      obj.diagnosticId2 = obj.diseaseType2;
      obj.diagnosticName2 = obj.diseaseName;
      Object.assign(this.patientInfo, obj);
    },
    getPatientAnanAuth() {
      let obj = {
        patientCode: this.patientInfo.patientCode,
      };
      this.api2("getPatientAnanAuth", obj)
        .then((res) => {
          if (res.result && res.result.bindStatus == "1") {
            this.isAnAn = true;
          } else {
            this.isAnAn = false;
          }
        })
        .finally(() => {});
    },
    openPatientLabels() {
      this.$refs.patientLabelsRef.open();
    },
    setTabs() {
      this.tabs = [
        {
          label: "用户记录",
          value: 1,
          active: false,
        },
      ];
      if (this.showHandPic) {
        this.tabs.push({
          label: "手相解读",
          value: 3,
          active: false,
        });
      }
      if (this.hasBaiHui && hasAuth("YZ-12")) {
        this.tabs.push({
          label: "用户提问",
          value: 2,
          active: false,
        });
      }
      if (this.showCaseAnalysis) {
        this.tabs.push({
          label: "病案分析",
          value: 4,
          active: false,
        });
      }
    },
  },
  mounted() {
    this.setTabs();
    this.init();
  },
};
</script>

<style lang="scss" scoped>
@import url("./style.css");
.details3 {
  .hobby,
  .remarks_input {
    display: inline-block;
  }
  :deep {
    .open-btn .text {
      display: none;
    }
  }

  .patientName {
    &.isPassAway {
      color: #888;
    }
  }
  .tag {
    background: #aaa;
    color: #fff;
    font-size: 12px;
    font-weight: normal;
    border-radius: 3px;
    margin-left: 10px;
    padding: 1px 5px;
  }
}
.chart-tab {
  height: 100%;
  padding: 20px;
}
.patientinfo-other {
  .ivu-icon {
    cursor: pointer;
  }
}
.btn-group {
  padding-top: 8px;
  padding-bottom: 10px;
  margin-bottom: 10px;
  border-bottom: 1px solid #ddd;
  .ivu-btn + .ivu-btn {
    margin-left: 10px;
  }
}
.tag-box {
  display: flex;
  justify-content: space-between;
  padding-bottom: 5px;
  .tag-box-title {
    font-weight: bold;
  }
  .tag-box-btn {
    & + .tag-box-btn {
      margin-left: 10px;
    }
    cursor: pointer;
    &:hover {
      color: #2d8cf0;
    }
  }
}
.tag-bl {
  .patientinfo-other {
    width: 100%;
  }
}
</style>